import { chunk } from 'lodash-es';
import pMap from 'p-map';

import { destroy, get, post, put, downloadBlob } from '../lib/api';

export function getFields(growerId) {
  return get(`/${growerId}/soil-sample-order/fields`);
}

export function getPointsMap(growerId, aaid) {
  return get(`/growers/${growerId}/soil-sample-order/${aaid}/points/map`);
}

export function getOrderDomainData() {
  return get('/soil-sample-order/domain');
}

export function getEligibleSamplers(orderId) {
  return get(`/soil-sample-order/orders/${orderId}/eligible-samplers`);
}

export function createOrders(growerId, orderForm = {}) {
  return post(`/${growerId}/soil-sample-order/orders`, orderForm);
}

export function updateOrder(growerId, order = {}) {
  growerId = growerId || order.growerId;
  return put(
    `/${growerId || order.growerId}/soil-sample-order/orders/${order.id}`,
    order,
  );
}

export function acceptOrder(order) {
  return put(`/soil-sample-order/orders/${order.id}/accept`, order);
}

export function rejectOrder(order) {
  return put(`/soil-sample-order/orders/${order.id}/rejection`, {
    reason: order.rejectReason || undefined,
    notes: order.notes || undefined,
  });
}

export async function updatePoints(growerId, aaid, payload) {
  return put(
    `/growers/${growerId}/soil-sample-order/${aaid}/points`,
    payload,
  ).then((result) => (Array.isArray(result) ? { points: result } : result));
}

export function deleteOrder(growerId, id) {
  return destroy(`/${growerId}/soil-sample-order/orders/${id}`);
}

export function getOrders({ growerId, page, pageSize } = {}) {
  return growerId
    ? get(`/${growerId}/soil-sample-order/orders`)
    : get('/soil-sample-order/orders', { params: { page, pageSize } });
}

export function getCompletedOrders(year) {
  return get(`/soil-sample-order/orders?complete=true&year=${year}`);
}

export function getUrgentOrders() {
  return get('/soil-sample-order/orders', { params: { urgent: true } });
}

export function getInternalOrder(id, filters) {
  return get(`/soil-sampling/internal/orders/${id}`, { params: filters });
}

export function getInternalOrders(filters, selectedIds) {
  return get('/soil-sampling/internal/orders', {
    params: { ...filters, selected: selectedIds },
  });
}

export function getCompletedInternalOrders(filters) {
  return get('/soil-sampling/internal/orders', {
    params: { ...filters, complete: true },
  });
}

export function getDashboardStats() {
  return get('/soil-sampling/internal/stats');
}

export function getOrder(id) {
  return get(`/soil-sample-order/orders/${id}`);
}

export function approveOrders(ids) {
  return batchPost(`/soil-sample-order/orders/approvals`, ids);
}

export function unapproveOrders(ids) {
  return batchPost(`/soil-sample-order/orders/unapprovals`, ids);
}

export function finalizeOrders(ids) {
  return batchPost(`/soil-sample-order/orders/finales`, ids);
}

function batchPost(path, payload) {
  return pMap(chunk(payload, 25), (batch) => post(path, batch), {
    concurrency: 1,
  }).then((results) => results.flat());
}

export function styleResultDate(yearsUntilNeeded) {
  if (yearsUntilNeeded === 0) return { color: 'white', bgcolor: '#B00020' };
  if (yearsUntilNeeded === 1) return { bgcolor: '#E6A33D' };
  if (yearsUntilNeeded > 1) return { bgcolor: '#629749' };
}

export function exportFields() {
  return downloadBlob(`/soil-sample-order/export`);
}

export function exportPoints(growerId, aaids) {
  return downloadBlob(
    `/growers/${growerId}/soil-sample-order/points/shapefile`,
    aaids,
  );
}

export function updateLicenseeOrder(growerId, aaid, patch) {
  return put(`/growers/${growerId}/soil-sample-order/fields/${aaid}`, patch);
}

export function cancelLicenseeOrder(growerId, aaid) {
  return destroy(`/growers/${growerId}/soil-sample-order/fields/${aaid}`);
}
